import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { PageData, PageDataService } from './page-data.service';
import { LanguageService } from './language.service';

export const pageDataResolver: ResolveFn<PageData> = async route => {
  const pageDataService = inject(PageDataService);
  const langService = inject(LanguageService);
  const sectionType = Number(route.data?.['sectionType'] ?? 0);

  if (!sectionType) {
    return { sections: [] };
  }

  // Idioma del switcher runtime (LanguageService), no LOCALE_ID (estático del
  // build = 'en'). En el arranque puede no estar resuelto aún → cae a 'es'.
  return pageDataService.getPageData(
    sectionType,
    langService.currentLang() || 'es'
  );
};
